export default "/images/0ebc4eac79f3ccc78d64979aec5c350b.avif";